import { ClientConfigProductName } from '@frontend/vanilla/core';

export const ShowCaseLoader = {
    id: 'showcase',
    loaderFn: () => import(/* webpackChunkName: "ms-showcase" */ './showcase.feature'),
    product: ClientConfigProductName.SPORTS,
};
